module.exports = __webpack_public_path__ + "media/buy_report_icons/history-585d2b51.svg";